export default function getOrCreateRootElement() {
  var existing = document.getElementById('react-root');
  if (existing) {
    return existing;
  }
  var root = document.createElement('div');
  root.id = 'react-root';
  document.body.appendChild(root);
  return root;
}